import { AuthStoreType } from "store/type";

export const initGlobalState: AuthStoreType = {
	user: null,
	isUserSideBarAdmin: false,
	updateUserLoading: false,
	signInLoading: false,
	verifyOTPLoading: false,
	authenticationLoading: true,
	updateUserContrBtnLoading: false,
	removeUserProfileImgLoading: false,
	logOutModal: false,
	onRecordWalletStep: 0,
	getRetrieveKeyLoading: false,
	validateRetrieveKeyOTPLoading: false,
	secretKey: null,
	logoutLoading: false,
	didItLoading: false,
	didItVerificationUrl: undefined,
  didItSessionId: undefined,
	didItError: undefined,
};
